export default __webpack_public_path__ + "0c8aacd5843fc948eeaf41da122bcebe.jpg";